import { render } from "./OrderPayoffEditModal.vue?vue&type=template&id=08709256&scoped=true"
import script from "./OrderPayoffEditModal.vue?vue&type=script&lang=js"
export * from "./OrderPayoffEditModal.vue?vue&type=script&lang=js"

import "./OrderPayoffEditModal.vue?vue&type=style&index=0&id=08709256&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08709256"]])

export default __exports__